export const LOGOUT_PATH = '/api/core/auth/logout';
